import {ServiceMap} from 'types'
import {getAPIBaseUrl} from 'utils'
import {
  API_ACCEPT_PRIVACY_POLICY,
  API_2FA_EDIT_CRED_KYC,
  API_2FA_EDIT_CRED_KYC_LINK,
  API_2FA_EDIT_EMAIL_RESEND_CURRENT,
  API_2FA_EDIT_EMAIL_RESEND_NEW,
  API_2FA_EDIT_EMAIL_SEND_CURRENT,
  API_2FA_EDIT_EMAIL_SEND_NEW,
  API_2FA_EDIT_EMAIL_VERIFY_CURRENT,
  API_2FA_EDIT_EMAIL_VERIFY_NEW,
  API_2FA_EDIT_PHONE_RESEND_CURRENT,
  API_2FA_EDIT_PHONE_RESEND_NEW,
  API_2FA_EDIT_PHONE_SEND_CURRENT,
  API_2FA_EDIT_PHONE_SEND_NEW,
  API_2FA_EDIT_PHONE_VERIFY_CURRENT,
  API_2FA_EDIT_PHONE_VERIFY_NEW,
  API_PROFILE_BACKGROUND,
  API_PROFILE_BACKGROUND_LINK,
  API_PROFILE_PHOTO,
  API_PROFILE_PHOTO_LINK,
  API_ROBOYU_CUSTOMIZATION_STATUS,
  API_ROBOYU_SKINS,
} from 'consts'
import {ServiceParamMember} from './ServiceParamMember'

export const SERVICE_MAP_MEMBER: ServiceMap<ServiceParamMember> = {
  member_upload_profile_photo_link: {
    method: 'POST',
    url: getAPIBaseUrl() + API_PROFILE_PHOTO_LINK,
  },
  member_upload_profile_photo: {
    method: 'POST',
    url: getAPIBaseUrl() + API_PROFILE_PHOTO,
  },
  member_upload_background_photo_link: {
    method: 'POST',
    url: getAPIBaseUrl() + API_PROFILE_BACKGROUND_LINK,
  },
  member_upload_background_photo: {
    method: 'POST',
    url: getAPIBaseUrl() + API_PROFILE_BACKGROUND,
  },
  roboyu_skin_list: {
    method: 'GET',
    url: getAPIBaseUrl() + API_ROBOYU_SKINS,
  },
  roboyu_patch_skin: {
    method: 'PATCH',
    url: getAPIBaseUrl() + API_ROBOYU_SKINS,
  },
  roboyu_customization_status: {
    method: 'GET',
    url: getAPIBaseUrl() + API_ROBOYU_CUSTOMIZATION_STATUS,
  },
  accept_privacy_policy: {
    method: 'PATCH',
    url: getAPIBaseUrl() + API_ACCEPT_PRIVACY_POLICY,
  },
  member_2fa_edit_email_send_current: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_EMAIL_SEND_CURRENT,
  },
  member_2fa_edit_email_resend_current: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_EMAIL_RESEND_CURRENT,
  },
  member_2fa_edit_email_verify_current: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_EMAIL_VERIFY_CURRENT,
  },
  member_2fa_edit_email_send_new: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_EMAIL_SEND_NEW,
  },
  member_2fa_edit_email_resend_new: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_EMAIL_RESEND_NEW,
  },
  member_2fa_edit_email_verify_new: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_EMAIL_VERIFY_NEW,
  },
  member_2fa_kyc_link: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_CRED_KYC_LINK,
  },
  member_2fa_kyc: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_CRED_KYC,
  },
  member_2fa_edit_phone_send_current: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_PHONE_SEND_CURRENT,
  },
  member_2fa_edit_phone_resend_current: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_PHONE_RESEND_CURRENT,
  },
  member_2fa_edit_phone_verify_current: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_PHONE_VERIFY_CURRENT,
  },
  member_2fa_edit_phone_send_new: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_PHONE_SEND_NEW,
  },
  member_2fa_edit_phone_resend_new: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_PHONE_RESEND_NEW,
  },
  member_2fa_edit_phone_verify_new: {
    method: 'POST',
    url: getAPIBaseUrl() + API_2FA_EDIT_PHONE_VERIFY_NEW,
  },
}
